import { render, staticRenderFns } from "./ZDdetils.vue?vue&type=template&id=1a380e94&"
import script from "./ZDdetils.vue?vue&type=script&lang=js&"
export * from "./ZDdetils.vue?vue&type=script&lang=js&"
import style0 from "./ZDdetils.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports